module.exports = __webpack_public_path__ + "img/102-513a8c.png";